import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { AppContextConfigService } from "@obg/ngx.core";
import { PlatformService } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { BetaBadgeService } from "./beta-badge.service";

@Component({
	selector: "obg-m-beta-badge-container",
	templateUrl: "./beta-badge.container.html",
	styleUrls: ["./beta-badge.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class BetaBadgeContainer {
	@HostBinding("class.obg-m-beta-badge") hostCssClass = true;

	showBetaLink$: Observable<boolean> | undefined;
	showBetaLabel: boolean;

	constructor(
		private appContextConfig: AppContextConfigService,
		private betaBadgeService: BetaBadgeService,
		private platformService: PlatformService
	) {
		this.showBetaLabel = this.platformService.isBrowser && this.appContextConfig.showBetaLabel();
		this.showBetaLink$ = this.betaBadgeService.showBetaLinkHeader$();
	}

	goBackToOldSite() {
		this.betaBadgeService.goBackToOldSite();
	}
}
